export default __webpack_public_path__ + "static/media/minus.595a628f.svg";